import type { ReactNode } from 'react'

const TIMESTAMP = /\[?((?:\d{1,2}:)?\d{1,2}:\d{2})\]?/g

/** Seconds from `m:ss` or `h:mm:ss`, or null when it is not a time. */
export function parseClock(value: string): number | null {
  const parts = value.split(':').map((p) => Number(p))
  if (parts.length < 2 || parts.length > 3 || parts.some((p) => !Number.isInteger(p) || p < 0)) return null
  if (parts.slice(1).some((p) => p >= 60)) return null
  return parts.reduce((total, part) => total * 60 + part, 0)
}

/** Text with each m:ss or h:mm:ss turned into a button that seeks the player. */
export function withTimestamps(text: string, onSeek: (ms: number) => void): ReactNode[] {
  const parts: ReactNode[] = []
  let last = 0
  for (const match of text.matchAll(TIMESTAMP)) {
    const seconds = parseClock(match[1] ?? '')
    const at = match.index ?? 0
    if (seconds == null) continue
    parts.push(text.slice(last, at))
    parts.push(
      <button key={at} type="button" className="tx-link" onClick={() => onSeek(seconds * 1000)} title="Play from here">
        {match[0]}
      </button>,
    )
    last = at + match[0].length
  }
  parts.push(text.slice(last))
  return parts
}
